<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="650px">
        <v-card>
          <v-card-title>
            <span class="headline">添加白名单</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <form class="form">
                <!--begin::Body-->
                <div class="card-body p-1">
                  <div class="form-group row">
                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >发票类型</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="la la-money-bill-wave"></i>
                          </span>
                        </div>
                        <input
                          ref="inv_type"
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          placeholder="增值税电子普通发票"
                          v-model="form.inv_type"
                          disabled
                        />
                      </div>
                    </div>

                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >企业名称</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="la la-user-friends"></i>
                          </span>
                        </div>
                        <input
                          ref="business_name"
                          type="text"
                          required
                          class="form-control form-control-lg form-control-solid"
                          placeholder="请填写有效企业全称，必填项"
                          v-model="form.business_name"
                        />
                      </div>
                    </div>

                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >纳税人识别号</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="la la-500px"></i>
                          </span>
                        </div>
                        <input
                          ref="tax_id"
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          placeholder="请填写纳税人识别号，必填项"
                          v-model="form.tax_id"
                        />
                      </div>
                    </div>

                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >注册地址</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="la la-registered"></i>
                          </span>
                        </div>
                        <input
                          ref="register_address"
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          placeholder="请填写有效的企业注册地址，可选项"
                          v-model="form.register_address"
                        />
                      </div>
                    </div>

                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >开户银行</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="la la-bank"></i>
                          </span>
                        </div>
                        <input
                          ref="email"
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          placeholder="请填写企业的银行账户，可选项"
                          v-model="form.bank_name"
                        />
                      </div>
                    </div>

                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >银行账户</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="la la-user-check"></i>
                          </span>
                        </div>
                        <input
                          ref="email"
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          placeholder="请填写企业的银行账户，可选项"
                          v-model="form.bank_number"
                        />
                      </div>
                    </div>

                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >备注</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="la la-sticky-note"></i>
                          </span>
                        </div>
                        <input
                          ref="email"
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          placeholder="如果有额外要求，请备注说明，可选项"
                          v-model="form.memo"
                        />
                      </div>
                    </div>

                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >电子邮箱</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="la la-at"></i>
                          </span>
                        </div>
                        <input
                          ref="email"
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          placeholder="接收电子发票的邮箱，例如：marry@qq.com，必填项"
                          v-model="form.email"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!--end::Body-->
              </form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="white darken-1" @click="close">关闭</v-btn>
            <v-btn v-if="action === 'add'" color="primary" dark @click="save"
              >提交</v-btn
            >
            <v-btn v-else color="primary" dark @click="updateData">更新</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { postInstance } from "@/api/instance";
import { mapGetters } from "vuex";
import { putInstance } from "../../../api/instance";
export default {
  name: "AddInvTitle",
  computed: {
    ...mapGetters(["currentUserBalance", "currentUser"]),
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    form: {
      type: Object,
      required: true,
      default: function () {
        return {
          inv_type: "增值税电子普通发票",
        };
      },
    },
    action: {
      type: String,
      required: true,
      default: "add",
    },
  },
  data() {
    return {
      email: "",
    };
  },
  methods: {
    save() {
      postInstance("INVTITLE", this.form).then(() => {
        this.$emit("update:dialog", false);
        this.$parent.fetchInvTitle();
      });
    },
    updateData() {
      const queryData = {
        query: { _id: this.form._id["$oid"] },
        values: { $set: this.form },
      };

      putInstance("INVTITLE", queryData).then(() => {
        this.$emit("update:dialog", false);
        this.$parent.fetchInvTitle();
        this.$bvToast.toast("更新成功", {
          title: "",
          variant: "success",
          toaster: "b-toaster-top-center",
        });
      });
    },
    close() {
      this.$emit("update:dialog", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-sale {
  position: absolute;
  top: -8px;
  right: 0;
  background-color: orange;
  color: #fff;
  font-size: 10px;
  height: 16px;
  padding: 1px 3px;
}
</style>
